// E4 — the pure "apply the routing decision to the loop call" rule, extracted so
// the composition-root wiring stays a one-liner AND the critical invariants are
// unit-testable without rendering SessionWorkspace:
//   - OFF / no decision ⇒ overrides are byte-identical to today (readOnly false,
//     permissionsMode = the current value || 'ask');
//   - the router only ever TIGHTENS: a 'risky' role forces 'ask'; it NEVER relaxes
//     a permission to 'ignore'.
//
// PURE: zero imports.

/**
 * resolveLoopOverrides(routeDecision, currentPermissionsMode)
 *   → { readOnly:boolean, permissionsMode:'ask'|'ignore'|string }
 * `routeDecision` = the routeTurn() result | null. `currentPermissionsMode` = the
 * turn's existing mode (e.g. session.permissions_mode).
 */
export function resolveLoopOverrides(routeDecision, currentPermissionsMode) {
  const base = currentPermissionsMode || 'ask';
  return {
    ...(routeDecision?.auto ? { maxCostUsd: routeDecision.maxCostUsd, maxTokensOut: routeDecision.maxTokensOut } : {}),
    // analysis/chat ⇒ read-only (mutating tools dropped). null/none ⇒ false (today).
    readOnly: !!(routeDecision && routeDecision.readOnly),
    // tighten-only: a routed 'ask' wins; anything else keeps the current mode. The
    // router can never produce 'ignore' here (it would have to come from `base`).
    permissionsMode: routeDecision && routeDecision.permissionsMode === 'ask' ? 'ask' : base,
  };
}
